var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordedActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "06969923-0906-4C0B-9BCA-03B45DAE1344@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coach",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-(-gym-owner-)-",
    transform: "translate(-31.000000, -376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SIDEBAR",
    transform: "translate(-1.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main",
    transform: "translate(9.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(23.000000, 273.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    cx: 9,
    cy: 9,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 9,
    cy: 9,
    r: 5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordedActivity);
export default __webpack_public_path__ + "static/media/recordedActivity.882dabcb2ec28b2e939fd4b0501a47b4.svg";
export { ForwardRef as ReactComponent };